import { Button } from "@mui/material";
import RegularModal from "Components/UI/Modals/RegularModal";

const ConfirmModal = ({ open, onClose, onConfirm, credit, invoice }) => {
  return (
    <RegularModal
      open={open}
      onClose={onClose}
      title="Koppla kredit"
      style={{ minWidth: "30%" }}
    >
      <div
        style={{ display: "flex", flexDirection: "column", margin: "15px 0px" }}
      >
        <span>{`Vill du koppla kredit ${credit?.OCR} mot inbetalning ${invoice?.OCR}?`}</span>
      </div>
      <div style={{ display: "flex", gap: "10px" }}>
        <Button variant="contained" onClick={() => onConfirm()}>
          Ja
        </Button>
        <Button onClick={() => onClose()}>Nej</Button>
      </div>
    </RegularModal>
  );
};

export default ConfirmModal;
